// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IHealthPolicyDeductibleDto
 */
export interface IHealthPolicyDeductibleDto {
    /**
     * 
     * @type {number}
     * @memberof IHealthPolicyDeductibleDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IHealthPolicyDeductibleDto
     */
    health_plan_deductible_config_id?: number;
    /**
     * 
     * @type {Date}
     * @memberof IHealthPolicyDeductibleDto
     */
    valid_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IHealthPolicyDeductibleDto
     */
    valid_to?: Date;
    /**
     * 
     * @type {string}
     * @memberof IHealthPolicyDeductibleDto
     */
    policy_status?: IHealthPolicyDeductibleDtoPolicyStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum IHealthPolicyDeductibleDtoPolicyStatusEnum {
    ACTIVE = 'ACTIVE',
    CANCELED = 'CANCELED',
    FUTURE = 'FUTURE',
    EXPIRED = 'EXPIRED'
}


/**
 * Check if a given object implements the IHealthPolicyDeductibleDto interface.
 */
export function instanceOfIHealthPolicyDeductibleDto(value: object): value is IHealthPolicyDeductibleDto {
    return true;
}

export function IHealthPolicyDeductibleDtoFromJSON(json: any): IHealthPolicyDeductibleDto {
    return IHealthPolicyDeductibleDtoFromJSONTyped(json, false);
}

export function IHealthPolicyDeductibleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IHealthPolicyDeductibleDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'health_plan_deductible_config_id': json['health_plan_deductible_config_id'] == null ? undefined : json['health_plan_deductible_config_id'],
        'valid_from': json['valid_from'] == null ? undefined : (new Date(json['valid_from'])),
        'valid_to': json['valid_to'] == null ? undefined : (new Date(json['valid_to'])),
        'policy_status': json['policy_status'] == null ? undefined : json['policy_status'],
    };
}

export function IHealthPolicyDeductibleDtoToJSON(json: any): IHealthPolicyDeductibleDto {
    return IHealthPolicyDeductibleDtoToJSONTyped(json, false);
}

export function IHealthPolicyDeductibleDtoToJSONTyped(value?: IHealthPolicyDeductibleDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'health_plan_deductible_config_id': value['health_plan_deductible_config_id'],
        'valid_from': value['valid_from'] == null ? undefined : ((value['valid_from']).toISOString().substring(0,10)),
        'valid_to': value['valid_to'] == null ? undefined : ((value['valid_to']).toISOString().substring(0,10)),
        'policy_status': value['policy_status'],
    };
}

